module.exports = __webpack_public_path__ + "static/img_1587-855646380a6e6697b08703184d5698ba.webp";